import React from 'react';
import Navbar from '../../components/Navbar';
import LabelCreate from '../../components/Label/LabelCreate';
import './LabelCreatePage.css';

const LabelCreatePage = () => {
  return (
    <div className="label-create-page">
      <Navbar />
      <div className="label-create-content">
        <h2>New FSA Label</h2>
        <LabelCreate />
      </div>
    </div>
  );
};

export default LabelCreatePage;
